module.exports = __webpack_public_path__ + "static/bath-be7faec995d857098feb56f5d8001e23.jpg";